const Popup = {
  SELECTORS: {
    container: '[data-js-popup]',
    containerIsVisibleOnce: '[data-js-popup-is-visible-once]',
    containerIsFragmentBased: '[data-js-popup-is-fragment-based]',
  },
  CLASSES: {
    bodyActive: 'is-popup-active',
    containerActive: 'popup--active',
  },
  init() {
    const containerElements = document.querySelectorAll(this.SELECTORS.container);

    containerElements.forEach((containerElement) => {
      const name = containerElement.getAttribute(this.SELECTORS.container.replace('[', '').replace(']', ''));
      const isFragmentBased = containerElement.hasAttribute(
        this.SELECTORS.containerIsFragmentBased.replace('[', '').replace(']', '')
      );
      const isMatchingFragment = window.location.hash.includes(name);

      const sessionStorageEntry = sessionStorage.getItem(`popup-${name}`);

      if (
        (isFragmentBased && isMatchingFragment && sessionStorageEntry !== 'true') ||
        (!isFragmentBased && sessionStorageEntry !== 'true')
      ) {
        document.body.classList.add(this.CLASSES.bodyActive);

        containerElement.classList.add(this.CLASSES.containerActive);
      }

      containerElement.onclick = (event) => {
        if (event.target === event.currentTarget || event.target.tagName === 'A') {
          document.body.classList.remove(this.CLASSES.bodyActive);

          containerElement.classList.remove(this.CLASSES.containerActive);

          const isVisibleOnce = containerElement.hasAttribute(
            this.SELECTORS.containerIsVisibleOnce.replace('[', '').replace(']', '')
          );

          if (isVisibleOnce) {
            sessionStorage.setItem(`popup-${name}`, true);
          }
        }
      };
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Popup.init();
});

document.addEventListener('shopify:section:load', () => {
  Popup.init();
});
